<div class="card dal-redirect-card">
    @if (isRedirectError()) {
        <h2 class="redirect-error">{{ 'redirect.dal.error' }}</h2>
    } @else {
        <h2>{{ 'redirect.dal.pleaseWait' | translate }}</h2>
    }
</div>
